<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="new-reports d-flex flex-column pb-2">
      <div
        class="
          new-reports-header
          py-2
          px-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="title-nav d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/goBack.svg"
            alt=""
            class="pointer"
            @click="goBack"
          />
          <span class="title">Vendor Reports</span>
        </div>
      </div>
      <div class="overview-tab px-3 py-3">
        <span class="tab-title">Overview</span>
        <div class="overview-items-flex d-flex align-items-center">
          <div class="overview-item">
            <span class="item-title">Active Vendors</span>
            <span class="item-value">{{ vendTotal }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Jobs Tagged</span>
            <span class="item-value">{{ vendTaggedCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Overall Candidates Pushed</span>
            <span class="item-value">{{ vendPushedCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Overall Candidates Selected</span>
            <span class="item-value">{{ vendSelectedCount }}</span>
          </div>
        </div>
      </div>

      <!-- Vendors Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Vendors</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img src="../../assets/ReportsNew/searchIcon.svg" alt="Search" />
              <b-form-input
                type="search"
                class="mb-1"
                placeholder="Search Vendors"
                v-model.trim="vendSearchQuery"
                debounce="500"
                @update="getSearchedVend"
              />
            </div>
            <button
              type="button"
              class="export-excel px-4 py-1"
              @click="openExcel"
            >
              Export Excel
            </button>
          </div>
        </div>
        <div class="custReport-main-table">
          <div class="mainCust-table-head">
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Vendor Name</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="vendSort != 'name'"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == 1"
                  @click="sortData('name', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == -1"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Total Jobs Tagged</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="vendSort != 'jobsTagged'"
                  @click="sortData('jobsTagged', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == 1"
                  @click="sortData('jobsTagged', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == -1"
                  @click="sortData('jobsTagged', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 25%">
              <div>Skills</div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Total Candidates Pushed</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="vendSort != 'candidatesPushed'"
                  @click="sortData('candidatesPushed', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == 1"
                  @click="sortData('candidatesPushed', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == -1"
                  @click="sortData('candidatesPushed', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Total Candidates Selected</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="vendSort != 'selectedCount'"
                  @click="sortData('selectedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == 1"
                  @click="sortData('selectedCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="vendSort && vendOrder == -1"
                  @click="sortData('selectedCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
          </div>
          <div class="mainCust-table-body p-1" @scroll="vendMainScroll">
            <template
              v-if="
                (vendorData.length == 0 &&
                  vendSearchQuery == '' &&
                  !vendScrollSpinner) ||
                vendMainSpinner
              "
            >
              <div
                style="margin: auto"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="vendorData.length == 0 && vendSearchQuery !== ''"
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ vendSearchQuery }}"
                </div>
              </div>
            </template>
            <template v-else-if="vendorData.length !== 0 && !vendMainSpinner">
              <div
                class="custReport-table-row pointer"
                v-for="(vend, vendIndex) in vendorData"
                :key="vendIndex"
                @click="selectRow(vend.name, vend.vendorUserID)"
                :class="
                  selectedRow == vend.vendorUserID ? 'cust-row-selected' : ''
                "
              >
                <div class="sideGridBlueColor"></div>
                <div class="text-truncate" style="width: 20%">
                  <div
                    v-b-tooltip.hover.top="vend.name"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ vend.name }}
                  </div>
                </div>
                <div style="width: 15%">{{ vend.jobsTagged }}</div>
                <div class="text-truncate" style="width: 25%">
                  <div
                    v-if="vend.skills && vend.skills.length > 0"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                    v-b-tooltip.hover="{
                      title: formattedSkillsTooltip(vend.skills),
                    }"
                  >
                    {{ formattedSkills(vend.skills) }}
                  </div>
                  <div v-else>-</div>
                </div>
                <div style="width: 20%" class="pl-1">
                  {{ vend.candidatesPushed }}
                </div>
                <div style="width: 20%" class="pl-1">
                  {{ vend.selectedCount }}
                </div>
              </div>
              <div
                style="margin: auto"
                v-if="vendScrollSpinner"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Overall Reports Section -->
      <div class="overall-reports relativeclass">
        <div
          class="
            overall-reports-header
            d-flex
            align-items-end
            justify-content-between
            w-100
          "
        >
          <div class="title-section d-flex flex-column" style="width: 75%">
            <span class="title">Overall Report</span>
            <span class="sub-title"
              >(Click on Vendor Name to see their report)</span
            >
          </div>
          <div
            class="d-flex align-items-center"
            style="position: absolute; right: 0"
          >
            <div
              class="filter-section d-flex align-items-center pr-4"
              ref="filter"
              v-closable="{
                exclude: ['filter', 'filterdropdown'],
                handler: 'cancelFilterSection',
              }"
            >
              <span>Show Results for: </span>
              <div class="custom-dropdown pl-3">
                <div
                  class="selected-filter d-flex align-items-center w-100"
                  @click="toggleReportsFilter"
                >
                  <div class="text-truncate" style="width: 90px">
                    <div
                      class="d-inline-block text-truncate mt-1"
                      style="min-width: auto; max-width: 100%"
                    >
                      <template v-if="selectedRow == 'all'">
                        All Vendors
                      </template>
                      <template v-else>
                        {{ selectedRowName }}
                      </template>
                    </div>
                  </div>
                  <div>
                    <img
                      src="../../assets/ReportsNew/chev_down_blue.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="filter-list-dropdown"
                  v-if="overallReportsFilter"
                  style="width: 265px"
                >
                  <div class="filter-search">
                    <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />
                    <b-form-input
                      type="search"
                      name="overallReportsSearch"
                      id="overallReportsSearch"
                      placeholder="Search"
                      v-model.trim="overAllSearchQuery"
                      debounce="500"
                      @update="getOverAllSeachedVend"
                    />
                  </div>
                  <div class="filter-list w-100" @scroll="scrollOverAllVend">
                    <template
                      v-if="
                        (overAllCustData.length == 0 &&
                          overAllSearchQuery == '' &&
                          !checkoverAllScrollLoader) ||
                        overAllMainLoader
                      "
                    >
                      <div
                        style="margin: auto"
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          mt-2
                          h-100
                        "
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </template>
                    <template
                      v-else-if="
                        overAllCustData.length !== 0 && !overAllMainLoader
                      "
                    >
                      <div
                        v-if="overAllSearchQuery == ''"
                        class="pointer"
                        @click="selectAllVendRow"
                        :class="selectedRow == 'all' ? 'cust-row-selected' : ''"
                      >
                        All Vendors
                      </div>
                      <div
                        class="w-100 wordbreak pointer"
                        v-for="(over, overIndex) in overAllCustData"
                        :key="overIndex"
                        @click="SelectOverallRow(over.name, over.vendorUserID)"
                        :class="
                          selectedRow == over.vendorUserID
                            ? 'cust-row-selected'
                            : ''
                        "
                      >
                        {{ over.name }}
                      </div>
                      <div
                        v-if="checkoverAllScrollLoader"
                        style="margin: auto"
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          mt-2
                        "
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overall-reports-flex">
          <div class="overall-reports-item px-1">
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="report-title px-3 py-2">
                <span class="title">Vendor Job Report</span>
              </div>
              <div
                v-if="!overallReportData"
                class="d-flex align-items-center w-50 justify-content-end pr-3"
              >
                <div class="legend-item d-flex align-items-center">
                  <span class="color-disc pushed"></span>
                  <span class="item-name">Candidates Pushed</span>
                </div>
                <div class="legend-item d-flex align-items-center ml-4">
                  <span class="color-disc selected"></span>
                  <span class="item-name">Selected Candidates</span>
                </div>
              </div>
            </div>

            <hr class="mt-0 mb-0" />

            <div class="overall-chart-overflow p-2">
              <div
                style="margin: auto"
                v-if="reportLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div
                v-else-if="overallReportData && !reportLoader"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/thirdPartyNodata.svg"
                  alt=""
                />
              </div>
              <div v-else style="overflow-y: auto" id="expandGraphChart"></div>
            </div>
            <!-- <div class="report-content p-2">
              <div class="sample-legend d-flex flex-column">
         
             
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Selected Candidates Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Selected Candidates</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />
              <b-form-input
                type="search"
                class="mb-1"
                placeholder="Search Candidates"
                v-model.trim="selectedVendSearchQuery"
                debounce="500"
                @update="getSelectedVend"
              />
            </div>
            <div class="daily-option">
              <button
                type="button"
                class="px-4 py-1 d-flex align-items-center"
                @click.stop="openDurationList"
              >
                <span>{{ DisplayTimeline }}</span>
                <img
                  src="../../assets/ReportsNew/chevron_down.svg"
                  alt="Open"
                />
              </button>
              <div
                class="report-duration-dropdown"
                style="margin-top: 2px"
                v-if="durationListOpen"
                ref="dropdown1"
              >
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'today' || this.storeTimeline == 'today'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('today')"
                >
                  Today
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisWeek' ||
                    this.storeTimeline == 'thisWeek'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisWeek')"
                >
                  This Week
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisMonth' ||
                    this.storeTimeline == 'thisMonth'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisMonth')"
                >
                  This Month
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisYear' ||
                    this.storeTimeline == 'thisYear'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisYear')"
                >
                  This Year
                </div>
                <div
                  class="duration-item custom p-0"
                  :style="
                    timeline == 'custom' && appliedFilter
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('custom')"
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      pointer
                    "
                    @click.stop="customDurationOpen = !customDurationOpen"
                    style="padding: 8px 10px"
                  >
                    <span>Custom</span>
                    <img
                      src="../../assets/ReportsNew/chevron_right.svg"
                      alt="Open Custom"
                      style="height: 8px"
                    />
                  </div>

                  <div
                    class="custom-duration-menu p-3"
                    v-if="customDurationOpen"
                    ref="dropdown2"
                  >
                    <span class="custom-title">Custom View</span>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'date'"
                        :label="'From Date'"
                        :mandatory="false"
                        :placeholder="'Choose From Date'"
                        :id="'fromDate'"
                        :format="'DD-MM-YYYY'"
                        :vmodel="fromDate"
                        @select-value="fromDate = $event"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'date'"
                        :label="'To Date'"
                        :mandatory="false"
                        :placeholder="'Choose To Date'"
                        :id="'toDate'"
                        :format="'DD-MM-YYYY'"
                        :vmodel="toDate"
                        @select-value="toDate = $event"
                        :startDate="fromDate"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'time'"
                        :label="'Start Time'"
                        :mandatory="false"
                        :placeholder="'Choose Start Time'"
                        :id="'startPanTime'"
                        :format="'HH:mm:ss'"
                        :vmodel="startTime"
                        @select-value="startTime = $event"
                        :disabled="fromDate == '' && toDate == ''"
                        icon="time"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'time'"
                        :label="'End time'"
                        :mandatory="false"
                        :placeholder="'Choose End Time'"
                        :id="'endPanTime'"
                        :format="'HH:mm:ss'"
                        :vmodel="endTime"
                        @select-value="endTime = $event"
                        :disabled="fromDate == '' && toDate == ''"
                        icon="time"
                      />
                    </div>

                    <div class="d-flex justify-content-between mt-4 bluebtn">
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="cancelCustom"
                        >Cancel</b-button
                      >
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter mr-3"
                          :disabled="fromDate == '' && toDate == ''"
                          @click="resetCustom"
                          >Reset</b-button
                        >
                        <b-button
                          class="acs-cancelBtn-filter"
                          :disabled="fromDate == '' && toDate == ''"
                          @click="applyCustom"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custReport-main-table">
          <div class="mainCust-table-head">
            <div class="d-flex align-items-center" style="width: 20%">
              <div>Candidate Name</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="selectedVendSort != 'candidateName'"
                  @click="sortSelectedData('candidateName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == 1"
                  @click="sortSelectedData('candidateName', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == -1"
                  @click="sortSelectedData('candidateName', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Job Name</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="selectedVendSort != 'title'"
                  @click="sortSelectedData('title', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == 1"
                  @click="sortSelectedData('title', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == -1"
                  @click="sortSelectedData('title', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              Skills
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Source</div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="selectedVendSort != 'source'"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == 1"
                  @click="sortSelectedData('source', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == -1"
                  @click="sortSelectedData('source', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <div>Experience <i style="font-weight: 400">(in years)</i></div>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="selectedVendSort != 'experince'"
                  @click="sortSelectedData('experince', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == 1"
                  @click="sortSelectedData('experince', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="selectedVendSort && selectedVendOrder == -1"
                  @click="sortSelectedData('experince', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              Action
            </div>
          </div>
          <div class="mainCust-table-body p-1" @scroll="selectedVendScroll">
            <template
              v-if="
                (selectedVendors.length == 0 &&
                  selectedVendSearchQuery == '' &&
                  !selectedVendScroll &&
                  !checkTimeLineData) ||
                selectedVendMainSpinner
              "
            >
              <div
                style="margin: auto"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="
                selectedVendors.length == 0 &&
                checkTimeLineData &&
                selectedVendSearchQuery == ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template
              v-else-if="
                selectedVendors.length == 0 && selectedVendSearchQuery !== ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ selectedVendSearchQuery }}"
                </div>
              </div>
            </template>
            <template
              v-else-if="
                selectedVendors.length !== 0 && !selectedVendMainSpinner
              "
            >
              <div
                class="custReport-table-row"
                v-for="(selectedVend, selectedIndex) in selectedVendors"
                :key="selectedIndex"
              >
                <div class="sideGridBlueColor"></div>
                <div class="text-truncate" style="width: 20%">
                  <div
                    v-b-tooltip.hover.top="selectedVend.candidateName"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ selectedVend.candidateName }}
                  </div>
                </div>
                <div class="text-truncate" style="width: 15%">
                  <div
                    v-b-tooltip.hover.top="selectedVend.title"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ selectedVend.title }}
                  </div>
                </div>
                <div style="width: 20%" class="text-truncate">
                  <div
                    v-if="selectedVend.skills && selectedVend.skills.length > 0"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                    v-b-tooltip.hover="{
                      title: formattedSkillsTooltip(selectedVend.skills),
                    }"
                  >
                    {{ formattedSkills(selectedVend.skills) }}
                  </div>
                </div>
                <div style="width: 15%" class="pl-1">
                  <template v-if="selectedVend.source == null"> - </template>
                  <template v-else>
                    {{ selectedVend.source }}
                  </template>
                </div>
                <div style="width: 15%" class="pl-1">
                  <template v-if="selectedVend.experince == ''"> - </template>
                  <template v-else>
                    {{ selectedVend.experince }}
                  </template>
                </div>
                <div style="width: 15%" class="pl-1">
                  <template>
                    <img
                      v-if="
                        selectedVend.candidateID !=
                        selectedCandidate.candidateID
                      "
                      v-b-tooltip.hover.top="'View Candidate'"
                      src="../../assets/talentpool/blueEye.svg"
                      alt=""
                      @click="viewCandidate(selectedVend)"
                      class="px-1 mr-2 pointer"
                    />

                    <img
                      v-else
                      src="../../assets/talentpool/notviewicon.svg"
                      alt=""
                      class="px-1 mr-2"
                    />
                  </template>
                </div>
              </div>
              <div
                style="margin: auto"
                v-if="selectedVendScrollSpinner"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- modal view particular candidates -->
    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidateID"
      :selectedCandidate="selectedCandidate"
      :customFieldsArray="customFieldsArray"
      :showActivate="true"
      :showNote="false"
      @close-view-icon="closeViewIcon"
    />
  </div>
</template>
<script>
import {
  getVendorReports,
  getVendorSelectedReports,
  getCustomerFields,
  getVendorJobReport,
  getVendorReportsExcel,
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import DateField from "../../components/InputComponents/DateField";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import { allExpandClass } from "vue-d3-charts-hire3x";
import { mapGetters } from "vuex";

export default {
  name: "VendorReports",
  components: {
    Spinner,
    DateField,
    PreviewCandidateSidebar,
  },
  data() {
    return {
      listSize: 40,
      skillListOpen: false,
      durationListOpen: false,
      customDurationOpen: false,
      LoaderStatus: false,
      reportLoader: true,
      appliedFilter: false,

      // vendor first table data
      vendPage: 0,
      vendCount: 10,
      vendSearchQuery: "",
      vendSort: "createdAt",
      vendOrder: -1,
      vendorData: [],
      vendMainSpinner: false,
      vendScrollSpinner: false,
      vendTotal: null,
      vendTaggedCount: null,
      vendPushedCount: null,
      vendSelectedCount: null,

      // overall variables
      selectedRow: "all",
      selectedRowName: "",
      selectedVendID: null,
      overAllSearchQuery: "",
      overAllCustData: [],
      overAllMainLoader: false,
      overallReportsFilter: false,
      overAllSort: "createdAt",
      overAllCount: 10,
      overAllVendPage: 0,
      overAllOrder: -1,
      overAllCustTotal: null,
      overAllCustPageEnd: null,
      checkoverAllScrollLoader: false,

      // selected vendor variables
      selectedVendors: [],
      selectedVendSearchQuery: "",
      selectedVendOrder: -1,
      selectedVendSort: "createdAt",
      selectedVendPage: 0,
      selectedVendCount: 10,
      selectedVendMainSpinner: false,
      selectedVendScrollSpinner: false,
      selectedVendTotal: null,
      selectedVendPageEnd: null,
      timeline: "thisMonth",
      storeTimeline: "thisMonth",
      fromDate: "",
      toDate: "",
      startTime: "",
      endTime: "",
      storeFromDate: "",
      storeToDate: "",
      storeStartTime: "",
      storeEndTime: "",

      selectedCandidate: {},
      viewCandidateModal: false,
      customFieldsArray: [],
      overallReportData: true,
      isExcelBoolean: false,
    };
  },
  created() {
    this.LoaderStatus = true;
    this.vendMainSpinner = true;
    this.getVendReports();
    this.selectedVendMainSpinner = true;
    this.getSelectedReports();
    this.getCustomField();
    this.overallVendorJobReport();
    if (this.$route.query.history) {
      this.viewCandidateModal = true;
      this.viewCandidate({ candidate: this.storedData.candidate });
    }
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    DisplayTimeline() {
      if (this.timeline == "today" || this.storeTimeline == "today") {
        return "Today";
      } else if (
        this.timeline == "thisWeek" ||
        this.storeTimeline == "thisWeek"
      ) {
        return "This Week";
      } else if (
        this.timeline == "thisYear" ||
        this.storeTimeline == "thisYear"
      ) {
        return "This Year";
      } else if (this.timeline == "custom" && this.appliedFilter) {
        return "Custom";
      } else if (
        this.timeline == "thisMonth" ||
        this.storeTimeline == "thisMonth"
      ) {
        return "This Month";
      } else {
        return this.storeTimeline;
      }
    },
    checkTimeLineData() {
      return (
        this.timeline == "today" ||
        this.timeline == "thisWeek" ||
        this.timeline == "thisYear" ||
        this.timeline == "thisMonth" ||
        this.timeline == "custom"
      );
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    convertDateFormat(dateStr) {
      if (dateStr) {
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`;
      } else {
        return "";
      }
    },
    handleClickOutside(event) {
      let picker = document.getElementsByClassName("mx-datepicker-main")[0];
      let timeItem = event.target.closest("li.mx-time-item");
      let dropdown = this.$refs.dropdown1;
      if (
        !picker?.contains(event.target) &&
        !dropdown?.contains(event.target) &&
        !timeItem
      ) {
        this.fromDate = this.storeFromDate;
        this.toDate = this.storeToDate;
        this.startTime = this.storeStartTime;
        this.endTime = this.storeEndTime;
        this.durationListOpen = false;
        this.customDurationOpen = false;
        if (!this.appliedFilter) {
          this.appliedFilter = false;
        }
      }
    },
    openExcel() {
      this.isExcelBoolean = true;
      this.LoaderStatus = true;
      this.getExcel();
    },
    async getExcel() {
      try {
        let payload = {
          excel: this.isExcelBoolean,
          sortBy: this.vendSort,
          order: this.vendOrder,
          searchQuery: "",
        };
        const res = await getVendorReportsExcel(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          // window.open(res.data.Detail.file);
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Vendor Reports.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (err) {
        console.error(err);
      }
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },

    async overallVendorJobReport() {
      if (
        document.getElementById("expandGraphChart") &&
        document.getElementById("expandGraphChart").innerHTML != ""
      ) {
        document.getElementById("expandGraphChart").innerHTML = "";
      }
      this.reportLoader = true;
      try {
        let payload;
        if (this.selectedVendID !== "") {
          payload = {
            vendorUserID: this.selectedVendID,
          };
        }
        const resp = await getVendorJobReport(payload);
        if (resp.status == 200) {
          const passData = resp.data.data;
          this.overallReportData = this.areAllCountsZero(
            passData,
            "candidatesPushed"
          );
          if (passData.length > 0) {
            const myData = Object.keys(passData)
              .map((key) => {
                return {
                  name: passData[key].title,
                  selectedVendorCandidates: passData[key].selectedCount,
                  vendorCandidates: passData[key].candidatesPushed,
                };
              })
              .filter((item) => item !== null);
            setTimeout(() => {
              if (document.getElementById("expandGraphChart").innerHTML != "") {
                document.getElementById("expandGraphChart").innerHTML = "";
              }
              const expandChart2 = new allExpandClass();
              expandChart2.vendorChart2(myData);
            }, 200);
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.reportLoader = false;
    },
    cancelFilterSection() {
      this.overallReportsFilter = false;
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    viewCandidate(selectedVend) {
      this.viewCandidateModal = true;
      this.selectedCandidate = selectedVend;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    openDurationList() {
      this.durationListOpen = !this.durationListOpen;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
    },
    cancelCustom() {
      this.fromDate = this.storeFromDate;
      this.toDate = this.storeToDate;
      this.startTime = this.storeStartTime;
      this.endTime = this.storeEndTime;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      if (!this.appliedFilter) {
        this.appliedFilter = false;
      }
    },
    resetCustom() {
      this.storeFromDate = "";
      this.storeToDate = "";
      this.storeStartTime = "";
      this.storeEndTime = "";
      this.fromDate = "";
      this.toDate = "";
      this.startTime = "";
      this.endTime = "";
      this.appliedFilter = false;
      this.timeline = "thisMonth";
      this.storeTimeline = "thisMonth";
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
      this.durationListOpen = false;
      this.customDurationOpen = false;
    },
    applyCustom() {
      this.appliedFilter = true;
      this.storeFromDate = this.fromDate;
      this.storeToDate = this.toDate;
      this.storeStartTime = this.startTime;
      this.storeEndTime = this.endTime;
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.storeTimeline = "custom";
      this.timeline = "custom";
    },
    setTimeline(value) {
      this.timeline = value;
      if (value !== "custom") {
        this.selectedVendMainSpinner = true;
        this.getSelectedReports();
        this.durationListOpen = false;
        this.customDurationOpen = false;
        this.storeTimeline = this.timeline;
        this.storeFromDate = "";
        this.storeToDate = "";
        this.storeStartTime = "";
        this.storeEndTime = "";
      }
    },
    async getSelectedReports() {
      try {
        let payload = {
          count: this.selectedVendCount,
          page: this.selectedVendPage,
          sortBy: this.selectedVendSort,
          order: this.selectedVendOrder,
          searchQuery: this.selectedVendSearchQuery,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedVendID !== "") {
          payload.vendorUserID = this.selectedVendID;
        }
        const res = await getVendorSelectedReports(payload);
        if (res.status == 200) {
          if (this.selectedVendPage == 0) {
            this.selectedVendors = res.data.data.data;
          } else {
            this.selectedVendors = [
              ...this.selectedVendors,
              ...res.data.data.data,
            ];
          }
          this.selectedVendTotal = res.data.data.total;
          this.selectedVendPageEnd = res.data.data.pageEnd;
          this.selectedVendScrollSpinner = false;
          this.selectedVendMainSpinner = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    getSelectedVend() {
      this.selectedVendScrollSpinner = true;
      this.selectedVendPage = 0;
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
    },
    selectedVendScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(
            this.selectedVendPageEnd,
            0,
            this.selectedVendTotal
          ) &&
          !this.selectedVendScrollSpinner
        ) {
          this.selectedVendScrollSpinner = true;
          this.selectedVendPage++;
          this.getSelectedReports();
        }
      }
    },
    sortSelectedData(sort, order) {
      this.selectedVendSort = sort;
      this.selectedVendOrder = order;
      this.getSelectedVend();
    },
    goBack() {
      if (this.$route.query.status == "dashboard") {
        this.$router.push({
          name: "MainDashboard",
        });
      } else {
        this.$router.push({
          name: "ReportDashboard",
        });
      }
    },
    scrollOverAllVend(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(
            this.overAllCustPageEnd,
            0,
            this.overAllCustTotal
          ) &&
          !this.checkoverAllScrollLoader
        ) {
          this.checkoverAllScrollLoader = true;
          this.overAllVendPage++;
          this.getOverAllVendors();
        }
      }
    },
    SelectOverallRow(name, id) {
      this.selectedRow = id;
      this.selectedRowName = name;
      this.selectedVendID = id;
      this.selectedVendPage = 0;
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.overallVendorJobReport();
    },
    selectRow(name, id) {
      if (this.selectedRow === id) {
        this.selectedRow = "all";
        this.selectedRowName = "";
        this.selectedVendID = "";
      } else {
        this.selectedRow = id;
        this.selectedRowName = name;
        this.selectedVendID = id;
      }
      this.selectedVendPage = 0;
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.overallVendorJobReport();
    },
    selectAllVendRow() {
      this.selectedRow = "all";
      this.selectedVendID = "";
      this.selectedVendPage = 0;
      this.selectedVendMainSpinner = true;
      this.getSelectedReports();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.overallVendorJobReport();
    },
    getOverAllSeachedVend() {
      this.checkoverAllScrollLoader = true;
      this.overAllVendPage = 0;
      this.overAllMainLoader = true;
      this.getOverAllVendors();
    },
    async getOverAllVendors() {
      try {
        let payload = {
          page: this.overAllVendPage,
          order: this.overAllOrder,
          count: this.overAllCount,
          sortBy: this.overAllSort,
          searchQuery: this.overAllSearchQuery,
        };
        const res = await getVendorReports(payload);
        if (res.status == 200) {
          if (this.overAllVendPage == 0) {
            this.overAllCustData = res.data.data.data;
          } else {
            this.overAllCustData = [
              ...this.overAllCustData,
              ...res.data.data.data,
            ];
          }
          this.overAllCustTotal = res.data.data.total;
          this.overAllCustPageEnd = res.data.data.pageEnd;
          this.checkoverAllScrollLoader = false;
          this.overAllMainLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    getSearchedVend() {
      this.checkoverAllScrollLoader = true;
      this.vendPage = 0;
      this.vendMainSpinner = true;
      this.getVendReports();
    },
    sortData(sort, order) {
      this.vendSort = sort;
      this.vendOrder = order;
      this.getSearchedVend();
    },
    vendMainScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.vendPageEnd, 0, this.vendTotal) &&
          !this.vendScrollSpinner
        ) {
          this.vendScrollSpinner = true;
          this.vendPage++;
          this.getVendReports();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    async getVendReports() {
      try {
        let payload = {
          page: this.vendPage,
          count: this.vendCount,
          searchQuery: this.vendSearchQuery,
          sortBy: this.vendSort,
          order: this.vendOrder,
        };
        const res = await getVendorReports(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          if (this.vendPage == 0) {
            this.vendorData = res.data.data.data;
          } else {
            this.vendorData = [...this.vendorData, ...res.data.data.data];
          }
          this.vendTotal = res.data.data.total;
          this.vendPageEnd = res.data.data.pageEnd;
          this.vendTaggedCount = res.data.data.totalJobsCount;
          this.vendPushedCount = res.data.data.totalCandidatesPushed;
          this.vendSelectedCount = res.data.data.totalSelectedCandidatesCount;
          this.vendMainSpinner = false;
          this.vendScrollSpinner = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    formattedSkills(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      const skillNames = skills.map((skill) => skill);
      if (skillNames.length <= 3) {
        return skillNames.join(", ");
      } else {
        return skillNames.slice(0, 3).join(", ") + "...";
      }
    },
    formattedSkillsTooltip(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      return skills.join(", ");
    },
    toggleReportsFilter() {
      this.overallReportsFilter = !this.overallReportsFilter;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.overAllVendPage = 0;
      this.overAllCustData = [];
      this.overAllMainLoader = true;
      this.getOverAllVendors();
    },
  },
};
</script>
<style scoped>
.new-reports {
  position: relative;
  padding: 15px 20px 0px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: scroll;
  font-family: "Lato", sans-serif;
}

.new-reports .new-reports-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.new-reports .new-reports-header .title-nav {
  gap: 18px;
}

.new-reports .new-reports-header .title-nav .title {
  color: #20639b;
  font-weight: 600;
  font-size: 20px;
}

.daily-option {
  position: relative;
}

.daily-option .report-duration-dropdown {
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 15px #82828290;
  z-index: 300;
}

.daily-option .report-duration-dropdown .duration-item {
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
}

.daily-option .report-duration-dropdown .duration-item:hover {
  background-color: #e8eff4;
}

.daily-option .report-duration-dropdown .duration-item.custom {
  position: relative;
}

.custom-duration-menu {
  position: absolute;
  background: #ffffff;
  right: 162px;
  bottom: -185px;
  box-shadow: 0 0 15px #82828290;
  border-radius: 6px;
  width: 280px;
}

.custom-duration-menu .custom-title {
  font-weight: 600;
  font-size: 16px;
}

.custom-duration-menu form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-duration-menu form .custom-button-field {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.custom-duration-menu form .custom-button-field button {
  padding: 4px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.custom-duration-menu form .custom-button-field button.cancel {
  color: #20639b;
  background-color: white;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-button-field button.apply {
  color: white;
  background-color: #20639b;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-input-field {
  display: flex;
  flex-direction: column;
}

.custom-duration-menu form .custom-input-field label {
  font-size: 14px;
}

.custom-duration-menu form .custom-input-field .date-picker-field {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #a8a8a8;
}

.custom-duration-menu form .custom-input-field .date-picker-field span {
  color: #667085;
}

.daily-option > button {
  gap: 18px;
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
}

.new-reports .overview-tab {
  background: #fff;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .overview-tab .tab-title {
  font-weight: 600;
}

.new-reports .overview-tab .overview-items-flex {
  gap: 32px;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-grow: 1;
}

.new-reports .overview-tab .overview-items-flex .overview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
}

.new-reports .overview-tab .overview-items-flex .overview-item .item-value {
  color: #20639b;
}

.new-reports .table-panel {
  background-color: #fff;
  border-radius: 6px;
  margin-top: 10px;
}

.new-reports .table-panel .table-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .table-panel .table-title-bar .table-title {
  font-weight: 600;
}

.new-reports .table-panel .table-title-bar .search-export-options {
  gap: 18px;
}

.new-reports .table-panel .table-title-bar .search-bar {
  /* gap: 12px; */
  background-color: #f4f4f6;
  width: max-content;
  border-radius: 20px;
}

.new-reports .table-panel .table-title-bar .search-bar input {
  background-color: transparent;
  border: none;
  height: 30px;
}

.new-reports .table-panel .table-title-bar .export-excel {
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
}

.new-reports .table-panel .table-container {
  position: relative;
}

.new-reports .table-panel .table-container .table-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .table-panel .table-container .table-pagination > * {
  flex: 1;
}

.new-reports .table-panel .table-container .table-pagination .go-to {
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .go-to span {
  font-size: 14px;
  color: #20639b;
}

.new-reports .table-panel .table-container .table-pagination .go-to input {
  width: 30px;
  font-size: 14px;
  border: 1px solid rgb(181, 181, 181);
}

.new-reports .table-panel .table-container .table-pagination .go-to img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub {
  gap: 12px;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub img {
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item {
  padding: 4px 8px;
  border-radius: 6px;
  color: #20639b;
  font-size: 14px;
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item.selected {
  background-color: #20639b;
  color: #fff;
}

.new-reports .table-panel .table-container .table-pagination .items-rows {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  font-size: 14px;
  color: #20639b;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .items-rows
  .rows-pp {
  gap: 10px;
}

.new-reports .table-panel .table-container .table-header {
  background-color: #e9f0f5;
  gap: 10px;
  display: flex;
  align-items: center;
}

.new-reports .table-panel .table-container .table-header .header-item {
  font-size: 14px;
  font-weight: 600;
  color: #20639b;
  gap: 4px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header {
  gap: 2px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header
  img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-header > * {
  flex: 1;
}

.new-reports .table-panel .table-container .table-data-rows {
  margin-top: 10px;
  max-height: 365px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.new-reports .table-panel .table-container .table-data-rows .data-row {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 3px solid #20639b;
  box-shadow: 0 0 15px #dedede;
}

.new-reports .table-panel .table-container .table-data-rows .data-row:hover {
  background-color: #e3e3fe;
}

.new-reports .table-panel .table-container .table-data-rows .data-row > * {
  flex: 1;
  font-size: 15px;
  font-weight: 400;
  color: #20639b;
}

.new-reports .sourced-skills {
  margin-top: 10px;
  border-radius: 6px;
  background-color: #fff;
}

.new-reports .sourced-skills .source-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .sourced-skills .source-title {
  font-weight: 600;
}

.new-reports .sourced-skills .skills-chips-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.new-reports .sourced-skills .skills-chips-flex .chip {
  background-color: #eff6fb;
  color: #85a9c8;
  font-size: 14px;
  font-weight: 500;
}

.new-reports .sourced-skills .skills-chips-flex .chip.show-all {
  background-color: #85a9c8;
  color: #eff6fb;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* Overall Reports Section */

.new-reports .overall-reports {
  margin-top: 10px;
}

.new-reports .overall-reports .overall-reports-header .title-section .title {
  font-weight: 600;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .title-section
  .sub-title {
  color: #888888;
  font-style: italic;
}

.new-reports .overall-reports .overall-reports-header .filter-section {
  gap: 10px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown {
  position: relative;
  font-size: 14px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .selected-filter {
  background-color: transparent;
  gap: 12px;
  color: #20639b;
  cursor: pointer;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown {
  position: absolute;
  right: 0;
  top: 30px;
  background-color: #fff;
  z-index: 300;
  border-radius: 6px;
  box-shadow: 0 0 15px #10101047;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search {
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search
  input {
  background-color: #f1f1f1;
  border: none;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list {
  display: flex;
  flex-direction: column;
  min-height: auto;
  max-height: 165px;
  overflow-y: scroll;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list
  > * {
  padding: 10px;
  cursor: pointer;
}

.new-reports .overall-reports .overall-reports-flex {
  display: flex;
  align-items: center;
  gap: 12px;
}

.new-reports .overall-reports .overall-reports-flex > * {
  flex: 1;
}

.new-reports .overall-reports .overall-reports-flex .overall-reports-item {
  background-color: #fff;
  border-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content {
  position: relative;
  min-height: 250px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  top: 25px;
  right: 25px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .legend-item {
  gap: 10px;
  font-size: 11px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .legend-item
  .color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
}

.color-disc.pushed {
  background-color: #f5d06e;
}

.color-disc.selected {
  background-color: #269c8a;
}

/* Overall Reports Section End*/

@media screen and (max-width: 1024px) {
  .new-reports {
    padding: 15px 20px 0px 20px;
  }
}

.overall-chart-overflow {
  /* min-height: 270px; */
  height: 280px;
  /* max-height: 400px; */
  overflow: auto;
}
</style>
